import modal from './modal/index.vue';
import counter from './counter/index.vue';
import suburb from './suburb/index.vue';
import address from './address/index.vue';
import datepicker from './datepicker/index.vue';
import cleanprice from './cleanprice/index.vue';

export default {
  modal,
  counter,
  suburb,
  address,
  datepicker,
  cleanprice
};


// WEBPACK FOOTER //
// ./src/components/index.js